import {createSlice} from '@reduxjs/toolkit'
import constants from '@/constants'
import requestService from '@/services/request'
import {toastService} from '@/api/toast'
import {i18n} from "@/locale/i18n";

const initialState = {
  feedback: {
    status: constants.IDLE,
    error: null,
  },
}

const feedback = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    postFeedbackStart: state => {
      state.feedback.status = constants.LOADING
    },
    postFeedbackSuccess: (state) => {
      state.feedback.status = constants.COMPLETE
    },
    postFeedbackError: (state) => {
      state.feedback.status = constants.ERROR
    },
    resetFeedbackStatus: state => {
      state.feedback.status = constants.IDLE
    },
  },
})

export const selectFeedbacksStatus = state => state.feedback.feedback.status

export const {
  postFeedbackStart,
  postFeedbackSuccess,
  postFeedbackError,
  resetFeedbackStatus,
} = feedback.actions

export default feedback.reducer

export const postFeedback = (payload) => async dispatch => {
  await dispatch(postFeedbackStart())

  try {
    const response = await requestService.post(`/suggestions/`, payload)
    const data = await response.json()

    await dispatch(postFeedbackSuccess(data))
  }
  catch (err) {

    if(err.status === 500)
    {
      toastService('fail', {
        title: i18n('common.errors.server_error.title'),
        body: i18n('common.errors.server_error.message'),
      })
    }

    dispatch(postFeedbackError(err))
  }
}
